class helpers {
    timeSince(ticks) {
        let t = parseInt(((new Date()).getTime() - ticks) / 1000, 0);
        if (t < 60) {
            return parseInt(t, 0) + ' s';
        } else if (t >= 60 && t < 3600) {
            return parseInt(t / 60, 0) + ' m';
        } else if (t >= 3600 && t < 86400) {
            return parseInt(t / 3600, 0) + ' h';
        } else if (t >= 86400 && t < 2592000) {
            return parseInt(t / 86400, 0) + ' d';
        } else if (t >= 2592000 && t < 31104000) {
            return parseInt(t / 2592000, 0) + ' mth';
        } else if (t >= 31104000) {
            return parseInt(t / 31104000, 0) + 'y';
        }
    }
}

export default new helpers()


// WEBPACK FOOTER //
// ./src/helpers/helpers.js